import { useState } from "react"

export function useRefreshComponent(){
  var [_,setRefreshing]=useState(0)
  return ()=>{
    setRefreshing(old=>old+1)
  }
}